import styled from "styled-components";

export const Tittle = styled.h4`
    margin-bottom: 10px;
`
export const SearchProduct = styled.div`
    display: flex;
    justify-content: space-between;

`;
export const ProductContainer = styled.div`

    div{
        width: 400px;
    }
`;

export const ErrMsgContainer = styled.div`
    color: red;
`